import { getModifiedPath } from './';
import { languages } from '../data';

export const mapTranslations = (translations, type) => {
  if (type === 'page') {
    return translations.map((translation) => {
      const match = Object.keys(languages).find(
        (key) => translation.language.slug === key
      );
      return {
        ...translation,
        uri: translation.uri.replace(`/${match}/`, `/${languages[match]}/`),
      };
    });
  }
  if (type === 'blog') {
    return translations.map((translation) => ({
      ...translation,
      uri: getModifiedPath(translation.uri),
    }));
  }

  return translations;
};
